import YandexMetrikaGoal from '~/enums/yandex-metrika-goal'
import YandexMetrikaService from '~/services/yandex-metrika-service'

export function useSearchboosterObserver () {
  const observeClassChange = () => {
    const targetElement = document.body
    const classNameToTrack = 'l-ss-c-popup-is-active'

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const element = mutation.target as HTMLElement

          if (element.classList.contains(classNameToTrack)) {
            YandexMetrikaService.sendMetricEvent(YandexMetrikaGoal.ViewCatalog)
          }
        }
      })
    })

    observer.observe(targetElement, { attributes: true, attributeFilter: ['class'] })

    return () => { observer.disconnect() }
  }

  onMounted(() => {
    const stopObserving = observeClassChange()

    onBeforeUnmount(() => {
      stopObserving()
    })
  })
}
